import { $erp, $admin } from "@/utils/https.js";
// 意向订单
export function createIntention(data) {
    return $admin().post(`/api/admin/order/intention`, data);
}

export function getIntentions(_params) {
    const params = { ..._params, is_purchase: 0 };
    return $admin().get(`/api/admin/order/intention`, { params });
}

export function updateIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}`, data);
}

export function deleteIntention(id) {
    return $admin().delete(`/api/admin/order/intention/${id}`);
}

export function getIntention(id) {
    return $admin().get(`/api/admin/order/intention/${id}`);
}

// 意向订单 开始洽谈
export function startIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/start`);
}

// 意向订单 开始签约
export function startSignIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/start_sign`);
}

// 保存意向订单
export function saveIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/save`, data);
}

// 意向订单 签约
export function signIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/sign`, data);
}

// 关闭意向订单
export function closeIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/close`, data);
}

// 提交审批
export function submitApprovalIntention(id, data) {
    return $admin().post(`/api/admin/order/intention/${id}/approve`, data);
}

// 获取审批详情
export function getApprovalIntention(params) {
    return $admin().get(`/api/admin/manage/ewx/approve`, { params });
}

// 通过审批后确认审批
export function confirmApprove(id) {
    return $admin().put(`/api/admin/order/intention/${id}/confirm_approve`);
}

// 移交订单
export function transferIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/transfer`, data);
}

// 获取我的意向订单统计
export function getMyIntentionCount(params) {
    return $admin().get(`/api/admin/order/intention/count/mine`, { params });
}

// 获取工单列表统计
export function getIntentionCount(params) {
    return $admin().get(`/api/admin/order/intention/group/stat`, { params });
}

// 获取订单日志
export function getIntentionLogs(order_id, params) {
    return $admin().get(`/api/admin/order/intention/log/${order_id}`, { params });
}

// 修改订单日志
export function changeIntentionLog(id, data) {
    return $admin().put(`/api/admin/order/intention/log/${id}`, data);
}

// 获取收款日志
export function getReceiptLogs(params) {
    return $admin().get(`/api/admin/manage/order/receipt_log`, { params });
}

// 备注收款日志
export function remarkReceiptLog(id, data) {
    return $admin().put(`/api/admin/manage/order/receipt_log/${id}/remark`, data);
}

// 录入订单
export function entryIntention(data) {
    return $admin().post(`/api/admin/order/intention/entry`, data);
}

// 更新录入订单 不能修改状态
export function entryUpdateIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/entry`, data);
}

// 生产
export function produceIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/produce`, data);
}

// 生产
export function produceBindIntention(id, task_id) {
    return $admin().put(`/api/admin/order/intention/${id}/produce-bind/${task_id}`);
}

// 发货
export function deliverIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/deliver`, data);
}

// 意向订单 安装
export function installIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/install`);
}

// 更改流程状态
export function updateIntentionWorkflow(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/workflow`, data);
}

// 意向订单 调试
export function debugIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/debug`);
}

// 意向订单 - 跳过
export function skipIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/skip`);
}

// 意向订单 验收
export function checkIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/check`, data);
}

// 意向订单 确认
// export function confirmIntention(id, data) {
//     return $admin().put(`/api/admin/order/intention/${id}/confirm`, data);
// }

// 意向订单 完成
export function finishIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/finish`, data);
}

// 意向订单 收款
export function receiptIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/receipt`, data);
}

// 意向订单 开票
export function invoiceIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/invoice`, data);
}

// 意向订单 归档
export function archiveIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/archive`, data);
}

// 生成验收单
export function acceptanceIntention(data) {
    return $admin().post(`/api/admin/manage/order/intention/sign`, data);
}

// 获取订单已发货的设备列表
export function getDeliveryDevices(params) {
    return $admin().get("/api/admin/order/delivery", { params });
}

// 补录订单信息
export function orderIntentionManualEnter(data) {
    return $admin().post(`/api/admin/order/intention/manual`, data);
}

// 获取intention统计数据
export function getIntentionStat(params) {
    return $admin().get("/api/admin/manage/stat/intention", { params });
}
//获取订单的安装工单
export function getOrderInstall(id) {
    return $admin().get(`/api/admin/order/intention/${id}`);
}

//获取市场统计数据
export function getMarketStat(params) {
    return $admin().get(`api/admin/manage/mkt/stat`, { params });
}

export function getMarketStatOverview(params) {
    return $admin().get(`api/admin/manage/mkt/stat/overview`, { params });
}

// 获取意向订单关联的市场部订单
export function getOrderMkt(id) {
    return $admin().get(`/api/admin/order/intention/${id}/related`);
}

// 关联市场部订单
export function relateMkt(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/relate`, data);
}

// 删除关联
export function delRelateMkt(id, internal_order_id) {
    return $admin().delete(`/api/admin/order/intention/${id}/relate?internal_order_id=${internal_order_id}`);
}

// 配货完成
export function allocateIntention(id) {
    return $admin().put(`/api/admin/order/intention/${id}/allocate`);
}

// 获取发货信息
export function getIntentionShip(id) {
    return $admin().get(`/api/admin/order/intention/${id}/ship`);
}

// 发起发货
export function shipIntention(id, data) {
    return $admin().put(`/api/admin/order/intention/${id}/ship`, data);
}

// 发货完成
export function shipIntentionDone(id) {
    return $admin().put(`/api/admin/order/intention/${id}/ship/done`);
}
